module.exports = __webpack_public_path__ + "img/3.33baa67b.jpg";